import { get } from 'svelte/store';
import { t } from 'svelte-i18n';

export enum TypeDocumentIdentiteEnum {
	CNI = 'CNI',
	PASSEPORT_UE = 'PASSEPORT_UE',
	PASSEPORT_HORS_UE = 'PASSEPORT_HORS_UE',
	PERMIS = 'PERMIS',
	CARTE_SEJOUR = 'CARTE_SEJOUR',
	AUTRE = 'AUTRE'
}

export const getTypeDocumentIdentiteEnumString = (e: TypeDocumentIdentiteEnum): string => {
	const $t = get(t);
	switch (e) {
		case TypeDocumentIdentiteEnum.CNI:
			return $t('kyc.inputs.typeDocument.cni');
		case TypeDocumentIdentiteEnum.PASSEPORT_UE:
			return $t('kyc.inputs.typeDocument.passeport');
		case TypeDocumentIdentiteEnum.PASSEPORT_HORS_UE:
			return $t('kyc.inputs.typeDocument.passeportHorsUE');
		case TypeDocumentIdentiteEnum.PERMIS:
			return $t('kyc.inputs.typeDocument.permis');
		case TypeDocumentIdentiteEnum.CARTE_SEJOUR:
			return $t('kyc.inputs.typeDocument.carteSejour');
		case TypeDocumentIdentiteEnum.AUTRE:
			return $t('kyc.inputs.typeDocument.autre');
		default:
			return '';
	}
};
